import { ITableHeaders } from 'interfaces/tableProps'

export const getMatchVisibleColumns = (newColumns: ITableHeaders[], visibleColumns: ITableHeaders[]): ITableHeaders[] => {
  return newColumns.map((newColumn) => {
    const visibleColumn = visibleColumns.find((v) => v.key === newColumn.key)
    return visibleColumn ? { ...newColumn, visible: visibleColumn.visible } : newColumn
  })
}

export const getVisibleColumns = (cols: ITableHeaders[]) => {
  return cols.filter(({ visible }) => visible !== 'hidden')
}
